import { render, staticRenderFns } from "./ShiftModal.vue?vue&type=template&id=36a74174&"
import script from "./ShiftModal.vue?vue&type=script&lang=ts&"
export * from "./ShiftModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports